import React from "react";
import styled from "styled-components";
import { Colors, TextFont, Text } from "../../../config";

const LineWithOrText = () => {
  return (
    <DashOrDash>
      <Line />
      <TextFont fontColor={Colors.doveGray} fontWeight="400">
        {Text.or}
      </TextFont>
      <Line />
    </DashOrDash>
  );
};

export default LineWithOrText;

const DashOrDash = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1rem;
`;
const Line = styled.div`
  width: 100%;
  border: 1px solid ${Colors.doveGray};
  opacity: 0.25;
`;
